import React from 'react'
import { Button, Form, Grid, Header, Segment, Image, Message } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'

import './Landing.css'

const LandingPV = (props) => {

  if (props.auth) {
    return <Redirect to='/home' />
  } else {
    return (
      <div>
      <style>{`
        html {
          background: url(/BG.jpg) no-repeat center center fixed;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        }
        body {
          overflow-x: hidden;
          background: none;
        }
      `}
      </style>
      <Grid centered columns={3}>
        <Grid.Column textAlign='center' className='login-grid'>
          <Image src='/SALIS.png' size='small' centered/>
          <Header className='login-title'>
            SALIS MIS
          </Header>
          <Header className='login-subtitle'>
            ST. ALPHONSUS LIGUORI INTEGRATED SCHOOL
          </Header>
          <Header as='h3' textAlign='center' className='login-header' attached='top'>
            Log-in to your account
          </Header>
          <Form size='large' attached='bottom' error={props.loginErr}>
            <Segment stacked>
              <Form.Input id='username' fluid placeholder='Username' error={props.loginErr} onChange={props.onUserChange}/>
              <Form.Input
                fluid
                placeholder='Password'
                type={(props.mask) ? 'password' : 'text'}
                icon={{
                  name: (props.mask) ? 'eye slash' : 'eye',
                  link: true,
                  onClick: props.togglePasswordMask
                }}
                id='password'
                error={props.loginErr}
                onChange={props.onPasswordChange}
              />
              <Message
                error
                header='Wrong username or password'
                content='If you forgot your password just contact your administrator.'
              />

            <Button fluid size='large' className='login-button' onClick={props.login}>
              Login
            </Button>
            {
              // <Button fluid size='large' className='login-button' onClick={props.signup}>
              //   Signup
              // </Button>
            }


            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </div>
    )
  }
}

export default LandingPV;
